module.exports = __webpack_public_path__ + "img/right.5bb1cb51.svg";